// The six areas Compass builds understanding of. The `note` is internal only —
// it guides the AI's private mental model and is NEVER rendered as a form field.
// Order here is the display order in the Understanding Review.
export const AREAS = [
  { key:"identity",   label:"Business Identity", note:"Who the company is: what it does, who it serves, and what makes it distinct." },
  { key:"goals",      label:"Business Goals",    note:"Where the company is trying to go: near- and long-term objectives and priorities." },
  { key:"valueChains",label:"Value Chains",      note:"How the company actually creates and delivers value, end to end." },
  { key:"kpis",       label:"KPIs",              note:"The numbers the business lives by — the metrics that signal health and progress." },
  { key:"vocabulary", label:"Vocabulary",        note:"The internal language, terms, and shorthand specific to this business." },
  { key:"rules",      label:"Business Rules",    note:"The constraints, policies, and non-negotiables the business operates under." },
];

// Fresh per-area understanding slot. Kept as a factory so each area gets its
// own object (no shared reference) when seeding initial state.
export function emptyUnderstanding() {
  return { understanding:"", status:"empty", confidence:0, openQuestion:null };
}

// Seed the full six-area understanding map, all empty.
export function seedAreas() {
  const map = {};
  for (const a of AREAS) map[a.key] = emptyUnderstanding();
  return map;
}
